/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CUL_FERTILIZACION_ITEM = {
  id: 'agro_cultivos_fertilizacion',
  screenId: 'agr-cul-fertilizacion',
  label: 'Fertilización',
  description: 'Plan nutricional de una siembra y registro rápido de aplicaciones.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Calculás cuánto nutriente necesita la siembra según escenario y rinde esperado, contrastado con lo disponible en suelo. También podés guardar una aplicación de fertilizante desde acá.',
      },
      {
        title: 'Paso 1 — Parámetros del plan',
        fields: [
          {
            label: 'Cultivo / siembra',
            description: 'Siembra sobre la que se calcula el plan.',
          },
          {
            label: 'Escenario',
            description: 'Escenario de extracción (Configuración → Necesidades nutricionales).',
          },
          {
            label: 'Rendimiento esperado (t/ha)',
            description: 'Rinde objetivo para estimar la demanda.',
          },
        ],
        paragraphs: ['Tocá «Generar plan» para ver indicadores y gráficos de nutrientes.'],
      },
      {
        title: 'Resultado del plan',
        bullets: [
          'Necesidad del cultivo, disponible en suelo y a aplicar, por nutriente.',
          'Gráficos de barras o apilados según el cálculo.',
        ],
      },
      {
        title: 'Guardar una aplicación',
        intro:
          'Si tenés permiso, podés abrir el formulario de aplicación y guardar un evento de fertilización vinculado a la siembra.',
        fields: [
          {
            label: 'Fecha',
            description: 'Día de la aplicación.',
          },
          {
            label: 'Fertilizante',
            description: 'Producto del maestro de fertilizantes (Eventos → Fertilización → Maestros).',
          },
          {
            label: 'Dosis',
            description: 'Cantidad aplicada.',
          },
          {
            label: 'Unidad',
            description: 'kg/ha o kg total.',
          },
          {
            label: 'Notas',
            description: 'Observaciones.',
          },
        ],
        paragraphs: ['Tocá «Guardar aplicación». También podés eliminar aplicaciones listadas si tenés permiso.'],
      },
    ],
  },
}
